import { FlowPage } from 'src/lib/flow/FlowPage';
import { isEligibleForLongboardingExperiment } from 'src/lib/flow/pageHelpers';

const isEnabled: FlowPage['isEnabled'] = (context) => {
  return (
    isEligibleForLongboardingExperiment(context) &&
    context.experimentFlags.longboarding == 'treatment'
  );
};

const longboardingAmenitiesPage: FlowPage = {
  slug: () => 'amenities',
  title: () => 'Which of these amenities are near your home?',
  isEnabled,
  autoAdvance: () => true,
  questions: () => [
    {
      key: 'home.amenities',
      type: 'multi_select',
      options: [
        {
          label: 'Cul de sac',
          value: 'cul_de_sac',
        },
        {
          label: 'End lot',
          value: 'end_lot',
        },
        {
          label: 'Parks',
          value: 'parks',
        },
        {
          label: 'Walkable area',
          value: 'walkable_area',
        },
        {
          label: 'Good schools',
          value: 'good_schools',
        },
        {
          label: 'Golf course',
          value: 'golf_course',
        },
        {
          label: 'Lake',
          value: 'lake',
        },
        {
          label: 'Nice views',
          value: 'nice_views',
        },
      ],
      showNoneOfTheAbove: true,
    },
  ],
};

export default longboardingAmenitiesPage;
